export const emptyRestaurantDraft = {
  name: '', address: '', phone: '', whatsapp_number: '', currency: '', tax_enabled: false, tax_rate: '0',
};

function textOrEmpty(value) {
  return typeof value === 'string' ? value : '';
}

export function draftFromSession(session) {
  const restaurant = session?.restaurant || {};
  return {
    ...emptyRestaurantDraft,
    ...restaurant,
    // The backend stores these as nullable; coerce null/undefined so no field ever holds a non-string.
    name: textOrEmpty(restaurant.name),
    address: textOrEmpty(restaurant.address),
    phone: textOrEmpty(restaurant.phone),
    whatsapp_number: textOrEmpty(restaurant.whatsapp_number),
    currency: textOrEmpty(restaurant.currency),
    tax_enabled: restaurant.tax_enabled === true,
    tax_rate: String(restaurant.tax_rate ?? 0),
  };
}

export function validateRestaurantDraft(draft) {
  if (textOrEmpty(draft.name).trim().length > 160) return 'nameTooLong';
  if (textOrEmpty(draft.address).trim().length > 500) return 'addressTooLong';
  if (textOrEmpty(draft.phone).trim().length > 40 || textOrEmpty(draft.whatsapp_number).trim().length > 40) return 'phoneTooLong';
  if (draft.currency && !/^[A-Z]{3}$/.test(textOrEmpty(draft.currency).trim().toUpperCase())) return 'currencyInvalid';
  const taxRate = Number(draft.tax_rate);
  if (!Number.isFinite(taxRate) || taxRate < 0 || taxRate > 100) return 'taxRateInvalid';
  if (!draft.tax_enabled && taxRate !== 0) return 'taxDisabledRate';
  return null;
}

function optionalText(value) {
  const trimmed = textOrEmpty(value).trim();
  return trimmed || null;
}

export function restaurantDraftPayload(draft) {
  const taxRate = Number(draft.tax_rate);
  return {
    name: optionalText(draft.name), address: optionalText(draft.address), phone: optionalText(draft.phone),
    whatsapp_number: optionalText(draft.whatsapp_number), currency: optionalText(draft.currency)?.toUpperCase() ?? null,
    tax_enabled: draft.tax_enabled, tax_rate: draft.tax_enabled ? taxRate : 0,
  };
}
